//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { API } from 'aws-amplify'
import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import getOrderedMentors from '~/gql/getOrderedMentors.js'

export default {
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    text: {
      type: String,
      default: '',
    },
    carouselType: {
      type: String,
      default: '',
    },
    link: {
      type: [String, Object],
      default: '',
    },
    headline: {
      type: String,
      default: 'h2',
      required: false,
    },
    size: {
      type: String,
      default: 'default',
    },
    items: {
      type: Array,
      default() {},
    },
    type: {
      type: String,
      default: 'PageCarousel',
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return { carouselItems: this.items }
  },

  async fetch() {
    if (this.carouselType === 'mentors') {
      const { data } = await API.get('api', '/mentor/getAllWithAvatar')

      const { mentorsOrdereds } = await this.$graphcms.request(
        getOrderedMentors,
        {
          locale: [this.$i18n.locale],
          lang: [this.$i18n.locale],
          target: 'banner',
        }
      )

      let items = mentorsOrdereds[0].mentors ?? []

      items = items.reduce((items, item) => {
        const itemInData = data.some((entry) => entry.graphcmsId === item.id)
        if (itemInData && items.length < 7) {
          items.push(item)
        }

        return items
      }, [])

      this.carouselItems.push(
        ...items.map((item) => {
          return {
            ...item,
            ...data.filter((dataItem) => item.id === dataItem.graphcmsId)[0],
          }
        })
      )
      this.carouselItems.push({
        title: this.$translation('showAllMentors'),
        link: '/connect/with-a-mentor',
        isViewAll: true,
        allCounter: this.carouselItems.length,
      })
    }
  },

  computed: {
    carouselID() {
      return this.carouselType.replace(/([a-z](?=[A-Z]))/g, '$1-').toLowerCase()
    },
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
}
